import React from 'react';
import { PauseIcon, PlayIcon, SquareIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useNow } from '../../hooks/useNow';
import { formatClock, timerElapsedMs } from '../../utils/time';
import { Button } from '../ui/Button';
export function TimerRunning() {
  const {
    timer,
    templateById,
    minutesToday,
    pauseTimer,
    resumeTimer,
    finishTimer
  } = useAppState();
  const now = useNow(timer?.status === 'running');
  if (!timer) return null;
  const template = templateById(timer.target.templateId);
  const elapsed = timerElapsedMs(timer, now);
  const target = template?.targetMinutes;
  const totalMin = template ? minutesToday(template.id) + Math.floor(elapsed / 60000) : 0;
  const running = timer.status === 'running';
  return <div className="text-center" data-id="element-1123" data-mp="31o64i903r7xm">
      <p className={`text-sm font-bold ${running ? 'text-accent-ink' : 'text-muted'}`} data-id="element-1124" data-mp="31n4r3xvm69cq">
        {running ? 'Teče' : 'Premor – čas se ne šteje'}
      </p>
      <p className="mt-1 text-6xl font-extrabold tabular-nums tracking-tight" aria-live="off" data-id="element-1125" data-mp="3gy3f4xbss4qb">
        {formatClock(elapsed)}
      </p>
      {target && <div className="mx-auto mt-5 max-w-xs" data-id="element-1126" data-mp="3ky5irc13f888">
          <div className="flex justify-between text-sm font-semibold" data-id="element-1127" data-mp="3pqoxicbio9em">
            <span data-id="element-1128" data-mp="3psi3dpeb2plk">Dnevni cilj</span>
            <span className="tabular-nums" data-id="element-1129" data-mp="3uq1j6tqnjafm">
              {totalMin}/{target} min
            </span>
          </div>
          <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-line" aria-hidden="true" data-id="element-1130" data-mp="2y0ap2vm9vpac">
            <div className={`h-full rounded-full ${totalMin >= target ? 'bg-done' : 'bg-accent'}`} style={{
          width: `${Math.min(100, totalMin / target * 100)}%`
        }} data-id="element-1131" data-mp="3202reql2oz79" />
          </div>
          <p className="mt-1.5 text-xs text-muted" data-id="element-1132" data-mp="3c0lh41zbj9x3">Vključene so prejšnje seje istega dne.</p>
        </div>}
      <div className="mt-6 grid grid-cols-2 gap-2" data-id="element-1133" data-mp="m9gj62fzzron">
        {running ? <Button variant="secondary" size="lg" onClick={pauseTimer} data-id="element-1134" data-mp="r7i0ahtv5gxh">
            <PauseIcon className="h-4 w-4" aria-hidden="true" data-id="element-1135" data-mp="1k4fyu1etw9g" /> Premor
          </Button> : <Button variant="secondary" size="lg" onClick={resumeTimer} data-id="element-1136" data-mp="3srgokko891dr">
            <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-1137" data-mp="bitohw7f24d1" /> Nadaljuj
          </Button>}
        <Button size="lg" onClick={finishTimer} data-id="element-1138" data-mp="6jqud6sz5iju">
          <SquareIcon className="h-4 w-4" fill="currentColor" aria-hidden="true" data-id="element-1139" data-mp="6l1xd4elim9w" /> Končaj
        </Button>
      </div>
      <p className="mt-4 text-xs text-muted" data-id="element-1140" data-mp="3f026qh62368a">
        Okno lahko zapreš – časovnik ostane viden v vrstici in se po ponovnem odprtju nadaljuje.
      </p>
    </div>;
}